module.exports = __webpack_public_path__ + "static/media/maria-headshot.be8db611.jpg";